import axios from 'axios';
import { useEffect } from 'react';
import { useHandleApiError } from '../utils/handleApiError';
import { useLoading } from '../context/LoadingContext';


export default function useAxiosInterceptors({ setErrorMessage, setErrorDetail, setLogoutOnClose } = {}) {
  const { setLoading } = useLoading();
  const handleApiError = useHandleApiError();
  useEffect(() => {
    const requestInterceptor = axios.interceptors.request.use(
      config => {
        setLoading(true); // Show loader for all requests
        return config;
      },
      error => {
        setLoading(false);
        return Promise.reject(error);
      }
    );

    const responseInterceptor = axios.interceptors.response.use(
      response => {
        setLoading(false);
        return response;
      },
      error => {
        setLoading(false);
        handleApiError(error.response || error, {
          setErrorMessage,
          setErrorDetail,
          setLogoutOnClose: typeof setLogoutOnClose === 'function' ? setLogoutOnClose : undefined
        });
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [setLoading, setErrorMessage, setErrorDetail, setLogoutOnClose, handleApiError]);
}
